import React, { useContext } from "react";

import { useCart } from "../../cart";
import { UserContext } from "../../contexts";
import { InfiniteScroll } from "../../components";
import { VerticalListing } from "./index.jsx";
import ListItemBoundary from "./ListItemBoundary.jsx";

const ListingList = ({
  url,
  list = "default",
  query = "",
  filters = {},
  firstPageOnly = false,
  maxItemsCount,
  sort = { field: "refreshed_at", direction: "desc" },
  limit,
  onResultsLoaded,
  itemComponent,
  isProduct,
  itemComponentProps = {},
  children = null,
  // Optional node shown instead of the plain "No products found." line (F5 empty states).
  empty,
}) => {
  const userContext = useContext(UserContext);
  const cart = useCart();

  const fetchParams = {
    list,
    query,
    filters,
    sort,
  };

  const ListItem = itemComponent || VerticalListing;

  return (
    <InfiniteScroll
      fetchUrl={url ?? "/api/listings/search"}
      fetchParams={fetchParams}
      firstPageOnly={firstPageOnly}
      maxItemsCount={maxItemsCount}
      emptyMessage="No products found."
      onResultsLoaded={onResultsLoaded}
      fetchLimit={limit || 8}
    >
      {({ items, isLoading, hasMore }) => (
        <div className="row">
          {items.length > 0 &&
            items.map((listing) => (
              // One bad listing must cost one tile, not the page — see ListItemBoundary.
              <ListItemBoundary
                key={listing.id}
                listingId={listing.id}
                reference={listing.reference_number || listing.product?.reference_number}
              >
                <ListItem
                  user={userContext.user}
                  listing={listing}
                  cart={cart}
                  isProduct={isProduct}
                  {...itemComponentProps}
                />
              </ListItemBoundary>
            ))}

          {!isLoading && items.length === 0 && (
            empty ?? (
              <div className="no-results">
                <p>No products found.</p>
              </div>
            )
          )}

          {!hasMore && children}
        </div>
      )}
    </InfiniteScroll>
  );
};

export default ListingList;
